import { render, staticRenderFns } from "./TopicView.vue?vue&type=template&id=fbd65698&scoped=true&"
import script from "./TopicView.vue?vue&type=script&lang=js&"
export * from "./TopicView.vue?vue&type=script&lang=js&"
import style0 from "./TopicView.vue?vue&type=style&index=0&id=fbd65698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd65698",
  null
  
)

export default component.exports